<template>
  <div>
    <v-data-table
      class="table-widget"
      :headers="headers"
      :items="items"
      :item-key="'id' + 'variant.id'"
      v-bind="$attrs"
      :items-per-page="1000"
    >
      <template v-slot:item.price="{ item }">
        <PriceField @set-value="(v) => (item.price = v)" :value="item.price" />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import PriceField from "../forms/fields/PriceField.vue";

export default {
  props: {
    headers: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
  },
  components: {
    PriceField,
  },
};
</script>

<style lang="scss">
.table-widget {
  .v-data-table__wrapper {
    overflow: hidden;
  }

  * {
    font-family: monospace;
    font-weight: bolder;
    color: black;
  }

  td {
    border-bottom: none !important;
  }

  td,
  th {
    padding: 0 4px !important;
    height: 24px !important;
  }
}
</style>
